import type { ValidationErrors } from '../../../utils/validation';
import type { IMedication } from '../../interfaces/medication';
import { medicationsSchema } from '../../../../common/validation/medication';
import { validate } from '../../../utils/validation';

export const medicationsErrorPrefix: string = 'medication_';

export function validateMedications(errors: ValidationErrors, medications?: IMedication[]) {
    if (medications) {
        const validationResult = validate(medicationsSchema, medications);

        errors.forEach((value, key) => {
            if (key && key.startsWith(medicationsErrorPrefix)) {
                errors = errors.remove(key);
            }
        });

        validationResult.errors.forEach((value, key) => {
            if (key) {
                errors = errors.set(medicationsErrorPrefix + key, value);
            }
        });
    }

    return errors;
}

export function checkMedicationsHaveErrors(errors?: ValidationErrors) {
    const medErrors = errors?.keySeq().toArray();

    return medErrors?.some((key) => key?.includes(medicationsErrorPrefix));
}
